import styled from 'styled-components'

export const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5em;
`
FormWrapper.displayName = 'FormWrapper'
